/* global feedbackSended */
/* global requestSetNightState */

function downloadFile(url) {
    feedbackSended = true;
    redirect(url);
    feedbackSended = false;
}

function redirect(d) {
    //TODO: Replace all hrefs with this function so that we can control how we handle page leavings
    if (isRecording) {
        openAlert("Leave site?", "Are you sure you want to leave?", ALERTTYPE.yes_no, false, false, function () {
            window.location = d;
        }, closeAlert)
    } else {
        if (pressedKeys['Control']) {
            window.open(d, '_blank');
        } else {
            window.location = d;
        }
    }
}

function redirectNewTab(d) {
    //TODO: Replace all hrefs with this function so that we can control how we handle page leavings
    if (isRecording) {
        openAlert("Leave site?", "Are you sure you want to leave?", ALERTTYPE.yes_no, false, false, function () {
            //window.location = d;
            window.open(d, "_blank") || window.location.replace(d);
        }, closeAlert)
    } else {
        //window.location = d;
        window.open(d, "_blank") || window.location.replace(d);

    }
}

function getElementAsHtml(el) {
    let div = document.createElement("div");
    div.appendChild(el);
    return div.innerHTML;
}

function getDomOfHtml(html) {
    return new DOMParser().parseFromString(html, "text/html")
}

function htmlToDom(html) {
    return getDomOfHtml(html);
}

function convertHtmlToDom(html) {
    return getDomOfHtml(html);
}

let loading_ct = 0;
let fullscreen_saving_ct = 0;

function initLoading() {
    loading_ct += 1;
    $('#load_noticer').show();
}

function initFullScreenSaving() {
    fullscreen_saving_ct += 1;
    setTimeout(function () {
        showFullScreenSaving();
    }, 500);

}

function showFullScreenSaving() {
    if( fullscreen_saving_ct > 0 )
        $('#fullscreen_save_noticer').show();
}

function finishedFullscreenSaving() {
    fullscreen_saving_ct -= 1;
    if (fullscreen_saving_ct === 0) {
        $('#fullscreen_save_noticer').hide();
    }
}

function finishedSaving() {
    loading_ct -= 1;
    finishedFullscreenSaving();
    if (loading_ct === 0) {
        $('#load_noticer').hide();
        $('#save_noticer').fadeIn("fast").delay(1200).fadeOut("fast");
    }
}

function finishLoading() {
    loading_ct -= 1;
    if (loading_ct === 0) {
        //$('#load_noticer').fadeOut("fast");
        $('#load_noticer').hide();
    }
}

function substr5(str) {
    if (str === null)
        return "";
    return str.substring(0, 5);
}

/**
 * @param isClosed
 */
function requestCloseMenuAjax(isClosed) {
    console.log(isClosed);
    let parameter1 = "";
    if (isClosed)
        parameter1 += "1";
    else
        parameter1 += "0";
    let url = "/ajax/general/setMenuState/" + parameter1;

    let aR = new AjaxParameter(url);
    aR.method = HTTPMETHOD.PUT;
    ajaxReq(aR);
}

function requestSetNightState(isNight) {
    console.log(isNight);
    let parameter1 = "";
    if (isNight)
        parameter1 += "1";
    else
        parameter1 += "0";
    let url = "/ajax/general/setNightState/" + parameter1;

    let aR = new AjaxParameter(url);
    aR.method = HTTPMETHOD.PUT;
    ajaxReq(aR);
}